export const ARGON2_SALT: string = import.meta.env.VITE_ARGON2_SALT ?? '';
if (!ARGON2_SALT) console.error('VITE_ARGON2_SALT tanımlı değil; build ortamını kontrol edin');
